import React from 'react';
import { Loader } from 'semantic-ui-react';

const LoadingPage = ({ props = {} }) => <Loader {...props} active />;

export default LoadingPage;
